import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CONTENT_TYPE } from 'shared/constants/general';
import { readSeriesList } from 'shared/modules/series/actions';
import ListContainer from 'shared/components/ListContainer/ListContainer';
import SeriesCreate from '../Series/SeriesCreate/SeriesCreate';
import SeriesListItemDetails from './SeriesListItemDetails';

export default function SeriesList() {
	const dispatch = useDispatch();
	const series = useSelector<any>((state) => state.series.list);
	const [ready, setReady] = useState(false);

	const [showCreate, setShowCreate] = useState(false);
	const toggleCreateNewSeries = useCallback(() => {
		setShowCreate((s) => !s);
	}, []);

	const init = useCallback(async () => {
		await dispatch(readSeriesList());
		setReady(true);
	}, [dispatch]);

	useEffect(() => {
		init();
	}, [init]);

	return (
		<>
			<ListContainer
				ready={ready}
				title="Series"
				items={series}
				actions={[{ label: 'Add Series', onClick: toggleCreateNewSeries }]}
				details={SeriesListItemDetails}
				type={CONTENT_TYPE.SERIES}
			/>
			{showCreate && <SeriesCreate onClose={toggleCreateNewSeries} />}
		</>
	);
}
